import { createSelector } from 'reselect';
import { getStudioSlice } from './page';

export const getStudioOrders = createSelector(
  [getStudioSlice],
  state => state.orders ?? []
);
